import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { TableCell, TableRow } from '@mui/material';
import {
  formatDistinctiveStyleCells,
  formatEligibility,
  formatTopMatch,
  nhStyleFingerprintPath,
} from '../../utils/nhStyleFingerprintSnapshot';

function NhStyleFingerprintTableRow({ identity }) {
  const navigate = useNavigate();
  const destination = nhStyleFingerprintPath(identity.identityId);
  const [firstStyle, secondStyle, thirdStyle] = formatDistinctiveStyleCells(identity);

  const handleOpen = useCallback(() => {
    navigate(destination);
  }, [destination, navigate]);

  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      navigate(destination);
    }
  }, [destination, navigate]);

  return (
    <TableRow
      hover
      tabIndex={0}
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
      sx={{ cursor: 'pointer' }}
    >
      <TableCell>{identity.displayName}</TableCell>
      <TableCell>{identity.kind}</TableCell>
      <TableCell>{identity.beerCount}</TableCell>
      <TableCell>{identity.mappedBeers}</TableCell>
      <TableCell>{formatEligibility(identity)}</TableCell>
      <TableCell>{firstStyle}</TableCell>
      <TableCell>{secondStyle}</TableCell>
      <TableCell>{thirdStyle}</TableCell>
      <TableCell>{formatTopMatch(identity)}</TableCell>
    </TableRow>
  );
}

export default NhStyleFingerprintTableRow;
